module.exports = __webpack_public_path__ + "static/media/logo.0ced2d30.png";